import React, {useEffect, useState} from 'react';
import styles from './MileageReport.module.scss';
import {useRedux} from "../../../../states/redux-state";
import Loader from "../../Billing/Other/Loader";
import {iMileageReportData, iMileageTrip, Units} from "../../../../shared/interfaces";
import PerfectScrollbar from "react-perfect-scrollbar";
import {friendlyDist} from "../../../../shared/helpers";
import {getDeviceUnits} from "../report-utils";
import {useMileagePagination} from "../../../../hooks/useMileagePagination";

const MileageReport = ({clientId, startTime, endTime, allDevices}) => {
  const displayRecords = useRedux(s => s.report.displayRecords) || [];
  const [mileageEntries, setMileageEntries] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [pageSize, setPageSize] = useState<number>(3);

  const {
    data: currentPageData,
    loading,
    currentPage,
    totalPages,
    nextPage,
    prevPage,
    hasNext,
    hasPrev
  } = useMileagePagination({
    allDeviceIds: allDevices,
    startDate: startTime,
    endDate: endTime,
    organizationKey: clientId,
    initialData: displayRecords,
    pageSize: pageSize
  });

  useEffect(() => {
    const processRecords = async () => {
      setIsProcessing(true);

      const enriched = await Promise.all(currentPageData.map(async (entry: iMileageReportData) => {
        const trips = await Promise.all(entry.trips.map(async (trip) => {
          const units = await getDeviceUnits(entry.firebaseDeviceId);

          return ({
            ...trip,
            units
          })
        }));
        return { ...entry, trips };
      }));

      setMileageEntries(enriched);
    };

    processRecords();

    setIsProcessing(false);
  }, [currentPageData]);

  const isLoading = loading || isProcessing;

  return (
    <div className={styles.MileageReport}>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {mileageEntries.length > 0 ? (mileageEntries.map((mileageEntry: iMileageReportData) => {
            return (
              <div key={mileageEntry.firebaseDeviceId} className={styles.MileageReportItem}>
                <span className={styles.MileageReportTitle}>
                  {mileageEntry.deviceName}
                </span>
                <PerfectScrollbar>
                  <div className={styles.MileageReportValues}>
                    {mileageEntry.trips.length > 0 ? mileageEntry.trips.map((value: iMileageTrip, idx: number) => {
                      return (
                        <div key={idx} className={styles.MileageReportValue}>
                          <span>{value.state}</span>
                          <span>{friendlyDist(value.mil, value.units)}</span>
                        </div>
                      );
                    }) : <div className={styles.MileageReportValue}><span>No data available for this device</span></div>}
                  </div>
                </PerfectScrollbar>
              </div>
            );
          })) : <div className={styles.MileageReportNoDevicesData}>No data for these devices</div>}
          {allDevices.length > pageSize && <div className={styles.MileageReportPagination}>
            <button
                className={styles.MileageReportPaginationBtn}
                onClick={prevPage}
                disabled={!hasPrev}
            >
              <span className={styles.MileageReportPaginationBtnText}>Previous</span>
            </button>
            <button
                className={styles.MileageReportPaginationBtn}
                onClick={nextPage}
                disabled={!hasNext}
            >
              <span className={styles.MileageReportPaginationBtnText}>Next</span>
            </button>
          </div>}
        </>
      )}
    </div>
  );
}

export default MileageReport;
